import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="export"
export default class extends Controller {
  static values = {
    url: String
  }
  connect() {
    console.log('Export controller connected!', this.element)
  }

  download(event) {
    console.log('Download method called!', event)
    event.preventDefault()

    // Get the form element
    const form = this.element.closest('form')
    if (!form) {
      console.error('Export controller: Could not find parent form')
      return
    }

    console.log('Form found:', form)

    // Collect form data
    const formData = new FormData(form)
    const params = new URLSearchParams()
    
    for (const [key, value] of formData.entries()) {
      // Skip the commit button values
      if (key !== 'commit') {
        params.append(key, value)
      }
    }

    console.log('Params collected:', params.toString())

    // Build the export URL with query parameters
    const exportUrl = `${this.urlValue}?${params.toString()}`

    console.log('Triggering download from:', exportUrl)

    // Trigger the download
    window.location.href = exportUrl
  }
}
